<template>
  <div class="row">
    <div class="col-md-12">
      <b-tabs
        id="tabs-1"
        key="tabs-1"
        fill
        class="esus-feedback-tabs"
        v-model="tabsActive"
      >
        <b-tab title="Lista" active>
          <template v-slot:title> <i class="icofont-list"></i> Lista </template>

          <div>
            <div class="info-table">
              <div class="select-situacao info-table-item">
                <vue-select
                  :options="situacaoOptions"
                  label="label"
                  placeholder="Identificação"
                  v-model="situacao"
                  @input="
                    situacao !== null
                      ? handleSituacao($event)
                      : handleSituacao('Todos')
                  "
                  :clearable="true"
                >
                  <template slot="option" slot-scope="option">
                    {{ option.label }}
                  </template>
                  <div slot="no-options">Não há opções correspondentes</div>
                </vue-select>
              </div>
              <div class="info-table-item">
                <download-files
                  :callback-pdf="generatePdf"
                  :data="displayedCadastros"
                  :fields="dataFields"
                  name="Cidadãos-duplicados"
                >
                </download-files>
              </div>
            </div>
            <tabela-cadastros-vuetfy
              :cadastros="cadastros"
              :loading="loading"
            ></tabela-cadastros-vuetfy>
          </div>
        </b-tab>
        <b-tab title="Resultado">
          <template v-slot:title>
            <i class="icofont-mathematical-alt-1"></i> Resultado
          </template>
          <div class="row">
            <div class="col-md-12">
              <tabela-resultado
                :loading="loading"
                :municipio="parseInt(valoresResultadoMunicipio)"
                :equipe="parseInt(valoresResultadoEquipe)"
              />
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import * as Functions from './functions.js'
import utils from '@/mixins/utils.js'
import TabelaCadastrosVuetfy from './TabelaCadastrosVuetfy.vue'
import TitleTag from '@/components/TitleTag.vue'
import TabelaResultado from './TabelaResultado.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
export default {
  name: 'CidadaosDuplicados',
  components: {
    TabelaCadastrosVuetfy,
    TabelaResultado,
    TitleTag,
    DownloadFiles,
  },
  mixins: [utils],
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
    ultimaAtualizacao() {
      return this.$store.getters['getUltimaAtualizacao']
    },
  },
  data() {
    return {
      tabsActive: 0,
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      equipes: [],
      equipe: '',
      profissionais: [],
      profissional: '',
      cadastros: [],
      page: 1,
      perPage: 10,
      pages: [],
      nome: '',
      total_de_registros_da_tabela: 0,
      loading: false,
      size: '40px',
      color: '#0D98BB',
      situacaoOptions: [
        { label: 'SEM CPF E CNS', value: 'sem-cpf-e-cns' },
        { label: 'COM CPF E SEM CNS', value: 'com-cpf-e-sem-cns' },
        { label: 'COM CNS SEM CPF', value: 'com-cns-e-sem-cpf' },
        { label: 'TODOS', value: 'todos' },
      ],
      situacao: '',
      cadastrosOriginais: [],
      tabelaResultado: [],
      valoresResultadoMunicipio: 0,
      valoresResultadoEquipe: 0,
      filterSearchTable: false,
      dataFields: {
        ...Functions.dataFields,
      },
    }
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    handleSituacao(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.page = 1
      const situacao = event.value
      this.cadastros = this.cadastrosOriginais
      if (situacao === 'todos') {
        this.cadastros = this.cadastrosOriginais
      } else {
        const filtrado = this.cadastros.filter((item) => {
          if (situacao === 'sem-cpf-e-cns') {
            return item.nu_cpf === null && item.nu_cns === null
          } else if (situacao === 'com-cpf-e-sem-cns') {
            return item.nu_cpf !== null && item.nu_cns === null
          } else if (situacao === 'com-cns-e-sem-cpf') {
            return item.nu_cns !== null && item.nu_cpf === null
          } else {
            return item
          }
        })
        this.cadastros = filtrado
      }
    },

    // Busca os dados referentes a cidade ao abrir a página
    async buscarCidadaosDuplicados() {
      try {
        this.loading = true
        let user = await this.$api.post('/app/usuario/auth', {
          cod_ibge: this.cod_ibge,
          id: this.user_id,
        })
        if (user) {
          this.situacao = {
            label: 'COM CNS SEM CPF',
            value: 'com-cns-e-sem-cpf',
          }
          const response = await Functions.getDadosPorProfissional(
            this.cod_ibge,
            user.data.cpf
          )
          this.cadastros = []
          this.cadastrosOriginais = response
          this.cadastros = response
          this.cadastros = this.cadastros.filter((item) => {
            return item.nu_cns !== null && item.nu_cpf === null
          })
          this.loading = false
        }
      } catch (error) {
        console.log(error)
      }
    },

    async buscarDadosResultado() {
      const response = await this.$api.get(
        `app/cidadaos-duplicados/${this.cod_ibge}/resultado`
      )
      this.tabelaResultados = response.data
      const municipio = this.tabelaResultados.reduce(
        (accumulator, currentObject) => {
          return accumulator + Number(currentObject.total_duplicados)
        },
        0
      )
      this.valoresResultadoMunicipio = municipio
      const equipe = this.tabelaResultados.find(
        (el) => el.nu_ine === this.$store.state.nu_ine
      )
      this.valoresResultadoEquipe = equipe.total_duplicados
    },
    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe
      )
    },
    init() {
      this.id_funcao = this.$store.state.id_funcao
      this.user_id = this.$store.state.id
      this.cod_ibge = this.$store.state.cod_ibge
      this.buscarCidadaosDuplicados()
      this.buscarDadosResultado()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style></style>
